import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { SHOP_URL } from "../lib/assets";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t-2 border-[#ff0044] bg-black mt-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid md:grid-cols-3 gap-8 items-start">
        <div>
          <div className="font-jp text-[#00ffff] glow-cyan text-3xl">世界転生</div>
          <div className="font-pixel text-[#ffe600] glow-yellow text-xl tracking-widest mt-1">SEKAI TENSEI</div>
          <p className="font-mono text-xs text-[#94a3b8] mt-3 leading-relaxed">
            {t.footer.credits}
          </p>
        </div>
        <div>
          <div className="font-pixel text-[#94a3b8] tracking-widest text-base">// NAV</div>
          <ul className="mt-3 space-y-1.5 font-mono text-sm">
            <li><a data-testid="footer-link-story" href="#story" className="hover:text-[#00ffff] hover:glow-cyan">▮ {t.story.title}</a></li>
            <li><a data-testid="footer-link-forms" href="#forms" className="hover:text-[#ff0044]">▮ {t.forms.title}</a></li>
            <li><a data-testid="footer-link-planets" href="#planets" className="hover:text-[#ffe600]">▮ {t.planets.title}</a></li>
            <li><a data-testid="footer-link-controls" href="#controls" className="hover:text-[#2bff88]">▮ {t.controls.title}</a></li>
            <li><a data-testid="footer-link-specs" href="#specs" className="hover:text-[#00ffff]">▮ {t.specs.title}</a></li>
          </ul>
        </div>
        <div>
          <div className="font-pixel text-[#94a3b8] tracking-widest text-base">// SHOP</div>
          <a
            data-testid="footer-shop-link"
            href={SHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-retro mt-3 inline-block"
          >
            ▶ {t.nav.shop}
          </a>
          <p className="font-mono text-xs text-[#94a3b8] mt-3">shop.nextworlds.com ↗</p>
        </div>
      </div>
      <div className="border-t border-white/5 px-6 py-4 text-center font-pixel text-[#94a3b8] text-sm tracking-widest">
        {t.footer.copy}
      </div>
    </footer>
  );
};

export default Footer;
